import UaParser from 'ua-parser-js'

export default {
  namespaced: true,
  state: {
    info: {} //系统信息
  },
  mutations: {
    /**
     * 读取系统信息
     */
    load(state) {
      state.info = new UaParser().getResult()
    }
  }
}
